const PHONE_CALL_EVENTS = {
  toggleSettings: "phoneCall_toggleCallSettings"
};

export default PHONE_CALL_EVENTS;
